<template>
  <div class="full-height no-padding" style="height: 100%">
    <div class="row full-height no-padding" style="height: 100%">
      <div class="col-4" style="padding-right: 0">
        <div
          style="
            overflow: scroll;
            max-height: 100%;
            min-height: 100%;
            overflow-x: hidden;
          "
        >
          <div v-if="!isInCurrentState('EDIT')" style="text-align: center">
            <md-button
              v-if="podeAdicionar"
              class="md-primary md-raised"
              @click="indexToAdicionar"
            >
              Adicionar Ponto
            </md-button>
          </div>

          <div v-if="isInCurrentState('INDEX')">
            <listagem-pontos-atualizados :local-id="localId" @flyTo="flyTo" />
          </div>

          <div v-if="isInCurrentState('SHOW')">
            <div>
              <md-progress-bar
                v-if="pontoSig.dataDetalhe && fetchingData"
                md-mode="query"
              />
              <loading :loading="!pontoSig.dataDetalhe" />
              <ponto-sig-detalhe
                v-if="pontoSig.dataDetalhe"
                ref="pontoSigDetalhe"
                :ponto.sync="pontoSig.dataDetalhe"
                @exit="showToIndex"
                @change="atualizaPonto"
              />
            </div>
          </div>

          <div v-if="isInCurrentState('CREATE')" style="text-align: center">
            <p v-if="!pontoSig.marker" class="md-headline">
              Selecione um ponto no mapa
            </p>
            <div v-if="pontoSig.marker">
              <p class="md-body-1">
                Coordenadas: {{ pontoSig.marker.lat.toFixed(6) }},
                {{ pontoSig.marker.lng.toFixed(6) }}
              </p>
              <p class="md-caption">
                Para redefinir o ponto basta selecionar no mapa novamente
              </p>
              <formulario-ponto-sig
                :local-id="localId"
                :localizacao="pontoSig.marker"
                @clickCancelar="adicionarToIndex"
                @changeTipo="changeTipo"
                @submit="submitPoint"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-8 no-padding" style="height: 100%">
        <PointSigMapBox
          ref="mapBox"
          :local-id="localId"
          @click="onClickMap"
          @marker-click="clickPoint"
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css'

import Loading from '../../components/Loading'
import FormularioPontoSig from '../../components/ponto-sig/FormularioPontoSig'
import ListagemPontosAtualizados from '../../components/ponto-sig/ListagemPontosAtualizados'
import PointSigMapBox from '../../components/ponto-sig/PontoSigMapBox.vue'
import PontoSigDetalhe from '../../components/ponto-sig/show/PontoSigDetalhe'
import crudState from '../../states/crud.state'
import http from '../../utils/http'

export default {
  name: 'PontoSigMapBoxIndex',
  components: {
    PointSigMapBox,
    Loading,
    PontoSigDetalhe,
    ListagemPontosAtualizados,
    FormularioPontoSig,
  },
  props: {},
  data() {
    return {
      localId: null,
      showSliderFotos: false,
      markers: [],
      fetchingData: false,
      state: crudState.INDEX,
      pontoSig: {
        marker: null,
        dataDetalhe: null,
        tipo: 1,
        cood: {
          lat: null,
          lng: null,
        },
      },
    }
  },
  computed: {
    podeAdicionar: function () {
      return this.state === crudState.INDEX
    },
  },
  watch: {
    state: function (val, oldVal) {
      if (oldVal === crudState.CREATE) {
        this.$refs.mapBox.removeTempMarker()
      }
    },
  },
  beforeMount() {
    this.localId = this.$route.params.localId

    this.$store.commit('togglePaddingPage')
  },
  async mounted() {
    this.markers = (
      await http.get('ponto-sig/local/' + this.localId + '/pontos-resumidos')
    ).pontos.map((e) => ({
      id: e.id,
      data: e.localizacao,
      tipo: e.tipo,
    }))
  },
  beforeDestroy() {
    this.$store.commit('togglePaddingPage')
  },
  methods: {
    indexToAdicionar() {
      this.state = crudState.CREATE
    },
    isInCurrentState(estado) {
      return this.state === crudState[estado]
    },
    adicionarToIndex() {
      this.state = crudState.INDEX

      this.pontoSig.marker = null

      this.pontoSig.tipo = 1
    },
    changeTipo(tipo) {
      this.pontoSig.tipo = tipo
    },
    async submitPoint() {
      this.adicionarToIndex()
      await this.$refs.mapBox.loadMarkers()
    },
    showToIndex() {
      this.state = crudState.INDEX
    },
    async atualizaPonto(id) {
      this.fetchingData = true
      this.pontoSig.dataDetalhe = await this.buscarPontoPorId(id)
      this.fetchingData = false
    },
    flyTo(ponto) {
      this.$refs.mapBox.flyTo(ponto.localizacao)
    },
    onClickMap(e) {
      if (this.state === crudState.CREATE) {
        this.pontoSig.marker = e.lngLat

        this.$refs.mapBox.addTempMarker(e.lngLat)
      }
    },
    async buscarPontoPorId(id) {
      return await http.get('ponto-sig/' + id)
    },
    async clickPoint(point) {
      if (this.state === crudState.INDEX || this.state === crudState.SHOW) {
        this.state = crudState.SHOW

        this.pontoSig.id = point.id
        this.pontoSig.cood = {
          lat: point.localizacao.lat,
          lng: point.localizacao.lng,
        }

        if (this.$refs.pontoSigDetalhe) {
          this.$refs.pontoSigDetalhe.historicoToDetalhe()
        }

        this.fetchingData = true
        this.pontoSig.dataDetalhe = await this.buscarPontoPorId(point.id)
        this.fetchingData = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.no-padding {
  margin: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.full-height {
  height: 100%;
}
</style>
